// extracted by mini-css-extract-plugin
export var label = "_3q-1";
export var reminder = "_3q-0";